import type { FunctionComponent } from 'react';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { LinkCollection } from '../../../components/LinkCollection/LinkCollection';

export const SuburbPageSurroundingSuburbsWithData: FunctionComponent = () => {
  const surroundingSuburbs = useSuburbPageQuery()?.data?.suburbPageBySlug?.surroundingSuburbs;
  if (!surroundingSuburbs) return null;

  const {
    title,
    subtitle,
    items: { visible, hidden },
    showMoreButton,
  } = surroundingSuburbs;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <LinkCollection
        visible={visible}
        hidden={hidden}
        showMoreButtonText={showMoreButton?.title}
      />
    </ContentBrick>
  );
};
